export default function SaveIcon({ className }: { className?: string }) {
  return (
    <svg
      className={`stroke-current ${className}`}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4745 1.97008C14.6262 2.03289 14.764 2.12495 14.8801 2.24102L17.759 5.11992C17.8751 5.23602 17.9671 5.37383 18.0299 5.52551C18.0927 5.67718 18.125 5.83974 18.125 6.00391V11.1617V16.3195C18.1236 16.7979 17.9329 17.2563 17.5946 17.5946C17.2563 17.9329 16.7979 18.1236 16.3195 18.125H3.68047C3.44336 18.1251 3.20856 18.0784 2.98949 17.9877C2.77041 17.897 2.57136 17.764 2.4037 17.5963C2.23603 17.4286 2.10304 17.2296 2.01233 17.0105C1.92161 16.7914 1.87495 16.5566 1.875 16.3195V3.68047C1.87495 3.44336 1.92161 3.20856 2.01233 2.98949C2.10304 2.77041 2.23603 2.57136 2.4037 2.4037C2.57136 2.23603 2.77041 2.10304 2.98949 2.01233C3.20856 1.92161 3.44336 1.87495 3.68047 1.875H13.9961C14.1603 1.87497 14.3228 1.90728 14.4745 1.97008Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5"
        y="5"
        width="9"
        height="4"
        rx="1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
